import { useEffect, useState } from 'react';
import { getGrades } from '../utils';
import { MdErrorOutline } from 'react-icons/md';

const LessonForm = ({ handleFormAction, video, lesson, loading, copy=false }) => {
    const [formData, setFormData] = useState(lesson || { video_id: video.id, title: video.title, description: video.description, grade_id: video.grade_id });
    const [error, setError] = useState({});
    const [Grades, setGrades] = useState([]);
    const required = {
        "title": "Lesson title",
        "description": "Lesson description",
        "grade_id": "Lesson grade",
    };

    useEffect(()=>{
      const fetchGrades = async () => {
        const Grades = await getGrades();
  
        setGrades(Grades);
      }
  
      fetchGrades();
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault();

        // check for missing required fields
        let missing = {};
        for (let key of Object.keys(required)) {
            if (!formData[key]) {
                missing[key] = `${required[key]} is required!`;
            }
        }
        if (Object.keys(missing).length !== 0) return setError(missing);

        await handleFormAction(formData, setError);
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value,
        })
    }

    return (
        <form onSubmit={handleSubmit} className="flex flex-col p-8 gap-2">
            <h1 className="mb-2 text-2xl">
                {
                    video &&
                    <>
                        Create lesson from
                        <span className="text-lightAqua ml-2">{video.title}</span>
                    </>
                }

                {
                    lesson &&
                    <>
                        {`${copy? 'Copy' : 'Update'}`}
                        <span className="text-lightAqua ml-2">{lesson.title}</span>
                    </>
                }
            </h1>

            <div className='flex flex-col'>
                <input type="text" id="title" className="input-bar" value={formData.title || ""} placeholder="Lesson Title *" onChange={handleChange} />
                {
                    error.title &&
                    <small className='text-red-700 flex items-center gap-1'>
                        <MdErrorOutline /> {error.title}
                    </small>
                }
            </div>

            <div className='flex flex-col'>
                <textarea rows={3} id="description" className="input-bar" value={formData.description || ""} placeholder="Lesson Description *" onChange={handleChange} />
                {
                    error.description &&
                    <small className='text-red-700 flex items-center gap-1'>
                        <MdErrorOutline /> {error.description}
                    </small>
                }
            </div>

            <div className='flex flex-col'>
                <select value={formData.grade_id || ""} id="grade_id" className="input-bar" onChange={handleChange}>
                    <option value="" disabled>Select Grade</option>
                    {Grades?.map((grade, idx) => (
                        <option
                            key={idx}
                            value={grade.id}
                        >
                            {grade.grade}
                        </option>
                    ))}
                </select>
                {
                    error.grade_id &&
                    <small className='text-red-700 flex items-center gap-1'>
                        <MdErrorOutline /> {error.grade_id}
                    </small>
                }
            </div>

            <button className="submit mt-2" disabled={loading}>
                {
                    loading ? <span className="loading text-gray-50" />
                        : video && 'Create Lesson' || lesson && `${copy? 'Copy' : 'Update'} Lesson` 
                }

            </button>
        </form>
    )
}

export default LessonForm